import {SignatureOutlined} from '@ant-design/icons'
import {useMapContext} from '@/components/MindMap/index.mjs'
import IconWithNotification from '../IconWithNotification.jsx'
import CommentedNodes from './CommentedNodes.jsx'

export default () => {
    const map = useMapContext()
    const nodes = [...map.useCommentedNodes()]

    return {
        icon: (
            <IconWithNotification notification={0 < nodes.length}>
                <SignatureOutlined />
            </IconWithNotification>
        ),

        key: 'comment',
        name: '批注',
        pane: <CommentedNodes nodes={nodes} />,
    }
}
